import { z } from "zod";
import {
    financialAccountSchema,
    integrationAccountResponseSchema,
} from "@common/schemas/financialAccount.schema";
import { subaccountSchema } from "@common/schemas/subaccount.schema";
import { financialConnectionResponseSchema } from "@common/schemas/domains/financialAccount/financial-connection-response.schema";
import { integrationConnectionResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";
import { entityResponseSchema } from "./entity-response.schema";

const entityContextIntegrationAccountResponseSchema =
    integrationAccountResponseSchema.extend({
        connection: financialConnectionResponseSchema.nullable().default(null),
        integrationConnection: integrationConnectionResponseSchema
            .nullable()
            .default(null),
    });

const entityContextFinancialAccountResponseSchema =
    financialAccountSchema.extend({
        order: z.number(),
        subaccounts: z.array(subaccountSchema),
        integrationAccounts: z.array(
            entityContextIntegrationAccountResponseSchema,
        ),
    });

export const entityContextResponseSchema = z.object({
    entity: entityResponseSchema,
    financialAccounts: z.array(entityContextFinancialAccountResponseSchema),
    mockEntityIncludesTransactions: z.boolean().optional(),
});

export const userEntitiesResponseSchema = z.object({
    entities: z.array(entityContextResponseSchema),
});

export type EntityContextResponseInput = z.input<
    typeof entityContextResponseSchema
>;
export type UserEntitiesWireResponse = z.output<
    typeof userEntitiesResponseSchema
>;
